// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"002e2a69","297":"4919ef25","407":"9ebf89b7","576":"01d8ebb1","845":"d4b6b59c","998":"f24402de"}[chunkId] + ".chunk.js";
};